module.exports = __webpack_public_path__ + "static/img/6837_phase_function_Paper_Points.99cff02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6837_phase_function_Paper_Points.png
// module id = Xsco
// module chunks = 0